import ModifierComboGroupButton from "./ModifierComboGroupButton";
// Returns a group container that holds a group button inside a modifier combo

export default function ModifierComboGroupContainer(props) {

    return (
        <>
            <div className="col-12">
                <hr className="text-body-tertiary"/>
            </div>
            <div className="col-12 pb-2">                
                <b>{props.modifierComboGroupDetails.modCategoryName}</b>
            </div>
            <div>
                <ModifierComboGroupButton
                    key={props.modComboGroupIndex}
                    modComboGroupIndex={props.modComboGroupIndex}
                    modComboGroupFormData={props.modComboGroupFormData}
                    modifierComboGroupDetails={props.modifierComboGroupDetails}
                    handleModifierComboGroupSelect={props.handleModifierComboGroupSelect}
                />
            </div>
        </>
    )
}